/*
 * @Date: 2018-08-23 09:14:38
 * @LastEditors: dwp
 * @LastEditTime: 2019-08-01 15:19:22
 * @Description: APP应用管理编辑页面 / model
 * @Company: Copyright (c) 2018. supOS
 */

import scriptUtil from 'root/utils/scriptUtil';
import commonMessage from 'root/common/messages.js';
import { createCtrl } from 'root/designer/utils/createClass';
import _ from 'lodash';
import { message } from 'antd';
import { routerRedux } from 'dva/router';
import { queryCurrent } from '../services/user';
import {
  addIndustryApplicationLayout,
  queryIndustryApplicationLayouts,
  removeIndustryApplicationLayout,
  updateIndustryApplicationPage,
  updateIndustryApplicationLayout,
  allResourcesInfo,
  saveRuntimeSetting
} from '../services/api';

import { lock, publishLayout, restoreLayout } from '../services/pageManager';

const { triggerEvent } = scriptUtil;

const root = createCtrl({
  id: 'ctrl-root',
  parentId: 0,
  type: 'Page', // 特殊页面级type
  index: 0,
  config: {
    style: {
      height: '100%',
      margin: '0 auto'
    }
  }
});
root.children = ['ctrl-0'];

const col = createCtrl({
  id: 'ctrl-0',
  parentId: 'ctrl-root',
  type: 'Col',
  index: 0,
  config: {
    ratio: '1',
    style: {}
  }
});
const defaultCtrls = {
  'ctrl-root': root,
  'ctrl-0': col
};

/*
* initPageConfig 记录初始状态的pageConfig  方便删除page 后初始化页面使用
* pageType 1-空白页面  2-链接页面  3-外部链接
*/
const initPageConfig = {
  platformLayoutType: 'PC',
  singleLayout: true,
  lwType: '1',
  lwValue: 0,
  lhValue: 0,
  linkage: '0',
  background: '',
  pageId: ''
};

const baseMobileLayout = [{
  mobileTabType: 'default-0',
  mobileLayoutNodes: []
}];

/**
* @description 递归计算组合是否可见
* 先获取是否在 group内,如果不在 则控件库是必显示;
* 如果在找到 group 的 id(即___d),判断是否可见;
* 如果不可见,则不计数,其他情况继续递归循环;
* @param {Object} child 该节点信息
* @param {Object} configObj 序列化后的节点信息
* @returns {Boolean} 是否显示 显示的话计数器加一  反之不加
*/
const recursiveIsVisable = (child = {}, configObj = {}) => {
  const target = _.get(child, 'p.parent', null);
  if (!target) return true;
  const id = _.get(target, '__i', null);
  if (id !== null) {
    const { a = {} } = configObj[id] || {};
    if (a['2d.visible'] === false) {
      return false;
    } else {
      try {
        return recursiveIsVisable(window.sameOriginParent, configObj);
      } catch (e) {
        console.log(e);
      }
    }
  }
};

export default {
  namespace: 'industryApplicationLayout',
  state: {
    isVisible: false,
    pageStatus: 0,
    pageLayout: [],
    layoutNodes: [],
    mobileLayout: Object.assign([], baseMobileLayout),
    layoutsAllConfig: {},
    runtimeAllConfig: {},
    initPageConfig: _.cloneDeep(initPageConfig), // 引用时注意深拷贝，该配置禁止手动更改
    pageConfig: _.cloneDeep(initPageConfig),
    pageInfo: {},
    linkPage: {},
    innerPage: {},
    pageType: '',
    formData: {},
    variableData: [],
    pageFormData: [],
    widgetCount: 0
  },
  effects: {
    *queryPageLayout({ payload }, { call, put }) {
      // 获取用户信息
      const userMsg = yield call(queryCurrent, payload);
      // 获取业务设计器页面
      const business = yield call(allResourcesInfo, { userId: userMsg.userSessionInfo.userId, resourceType: 'business' });
      // 获取app设计器页面
      const app = yield call(allResourcesInfo, { userId: userMsg.userSessionInfo.userId, resourceType: 'app' });
      yield put({
        type: 'getPage',
        payload: {
          business,
          app
        }
      });
    },
    *redirectToDesigner({ url, appId, pageId, parentId }, { call, put }) {
      const response = yield call(lock, pageId);
      if (response && !response.locked) {
        yield put(routerRedux.push(`${url}?appId=${appId}&pageId=${pageId}&parentId=${parentId}`));
      } else {
        yield put({
          type: 'toggleDisplayDialog',
          pageStatus: response.locked
        });
        yield put({
          type: 'setLockStaffName',
          lockStaffName: response.staffName,
          lastModifiedTime: response.lastModifiedTime
        });
      }
    },
    *forceUnlock({ url, appId, pageId }, { call, put }) {
      // 先定义接口
      // yield console.log(pageId, call);
      const response = yield call(lock, pageId, 'DELETE');
      // 测试 待删除
      if (response) {
        yield put({
          type: 'toggleDisplayDialog'
        });
        yield put(routerRedux.push(`${url}?appId=${appId}&pageId=${pageId}`));
      }
    },
    *fetchLayouts({ preMerge, id, requestSource, callback, isRuntime, sourceType, intl, isNew, isIframePage }, { call, put }) {
      const response = yield call(queryIndustryApplicationLayouts, id, isNew, preMerge);
      window.supQuery.debugMode('---------end---------');
      if (!(response && +response.code === 200)) return false;

      const {
        appId,
        layout,
        type,
        layouts,
        mobileShowType = 'auto',
        platformType = 'PC',
        name = '',
        navbarStyle = 'fixed',
        navbarFront = 'dark',
        navbarBgColor = '#ffffff',
        kind
      } = response;

      const pageInfo = {
        platformType
      };

      let supLinkInfo = {};

      supLinkInfo = {
        mobileShowType,
        navbar: {
          name,
          navbarStyle,
          navbarFront,
          navbarBgColor
        }
      };

      const {
        layoutNodes = [],
        pageConfig = _.cloneDeep(initPageConfig),
        mobileLayout = Object.assign([], baseMobileLayout)
      } = layout !== '' ? JSON.parse(layout) : {};

      // 当页面的layoutNode数量大于1时候置为非单页面应用
      const formatRuntimeConfig = {};

      if (type === 1) {
        const { length } = layoutNodes;

        if (length === 0) {
          message.error(intl.formatMessage(commonMessage.createPageError));
          return false;
        } else if (length === 1 && pageConfig.singleLayout === undefined) {
          pageConfig.singleLayout = true;
        } else if (length > 1) {
          pageConfig.singleLayout = false;
        }
      }

      // 解本处理工作流数据
      // if (layouts) {
      //   yield put({
      //     type: 'parseWorkFlowData',
      //     payload: layouts
      //   });
      // }

      // 工作流设计器需要
      if (requestSource && requestSource === 'bpmn') {
        yield put({
          type: 'bpmnWorkFlowData',
          payload: layouts
        });
        if (callback) callback();
      }

      /*
      *查询page 信息
      * type： 1-空白页面  2-链接页面  3-外部链接
      */
      switch (type) {
        case 1: {
          pageConfig.pageId = id;
          // 工作流渲染的页面不需要清空formData
          if (sourceType !== 'workProcess' && !isIframePage) {
            yield put({
              type: 'initFormData'
            });
          }
          yield put({
            type: 'saveLayoutsInfo',
            payload: {
              kind,
              appId,
              isRuntime,
              layouts,
              pageConfig,
              type,
              layoutNodes,
              mobileLayout,
              formatRuntimeConfig,
              pageInfo,
              supLinkInfo
            }
          });
          if (callback) callback('withWebsocketPreview');
          break;
        }
        case 2: {
          yield put({
            type: 'saveLinkInnerPageInfo',
            payload: Object.assign({}, response, { pageInfo, supLinkInfo })
          });
          if (callback) callback();
          break;
        }
        case 3: {
          yield put({
            type: 'saveLinkPageInfo',
            payload: Object.assign({}, response, { pageInfo, supLinkInfo })
          });
          if (callback) callback();
          break;
        }
        default:
          break;
      }
    },
    *resetFormData({ callback }, { put }) {
      yield put({
        type: 'initFormData'
      });
      if (callback) {
        callback();
      }
    },
    *addLayout({ payload, gridInfo, insertIndex = null, callback }, { call, put }) {
      if (JSON.parse(gridInfo).kind === 'new') {
        payload.context = JSON.stringify({ data: defaultCtrls });
      }
      const response = yield call(addIndustryApplicationLayout, payload);
      if (!(response && response.location)) {
        return false;
      }
      gridInfo = JSON.parse(gridInfo);
      gridInfo.id = response.location;
      const params = {
        type: insertIndex === null ? 'newFirstLayout' : 'normalLayout',
        gridInfo
      };
      yield put({
        type: 'increaseLayout',
        gridInfo,
        insertIndex
      });
      if (callback) callback(params);
    },
    *removeLayout({ payload, intl, callback }, { call, put }) {
      const res = yield call(removeIndustryApplicationLayout, payload.id);
      if (!(res && +res.code === 204)) return false;
      message.success(intl.formatMessage(commonMessage.delSuccess));
      yield put({
        type: 'deleteLayout',
        i: payload.i
      });
      if (callback) callback();
    },
    *updatePage({ payload, callback }, { call }) {
      yield call(updateIndustryApplicationPage, payload);
      if (callback) callback();
    },
    *updateLayout({ data, callback }, { call }) {
      const response = yield call(updateIndustryApplicationLayout, data);
      if (!(response && response.location)) {
        return false;
      }
      if (callback) yield callback();
    },
    *publish({ id, intl }, { call }) {
      const response = yield call(publishLayout, id);
      if (!(response && +response.code === 201)) return false;
      message.success(intl.formatMessage(commonMessage.publishSuccess));
    },
    *restore({ id, intl }, { call }) {
      const response = yield call(restoreLayout, id);
      if (!(response && +response.code === 201)) return false;
      message.success(intl.formatMessage(commonMessage.restoreSuccess));
    },
    *updateRumtimeLayout({ payload, callback }, { call }) {
      yield call(saveRuntimeSetting, payload);
      if (callback) callback();
    }
  },
  reducers: {
    bpmnWorkFlowData(state, { payload = [] }) {
      const variableData = [];
      const pageFormData = [];
      payload.forEach((list) => {
        const { context = {} } = JSON.parse(list.context);
        const data = _.get(context, 'jsonData.d', []);
        if (data && data.length !== 0) {
          data.forEach((item) => {
            const config = _.get(item, 'a.configs.config', {});
            if (!config.formItemId) return;
            variableData.push({
              instanceName: config.formItemId,
              instanceDesc: config.labelContent
            });
            pageFormData.push({
              name: config.labelContent,
              id: config.formItemId
            });
          });
        }
      });

      return {
        ...state,
        pageFormData,
        variableData: {
          list: variableData
        }
      };
    },
    toggleDisplayDialog(state, { pageStatus }) {
      return {
        ...state,
        pageStatus,
        isVisible: !state.isVisible
      };
    },
    setLockStaffName(state, { lockStaffName, lastModifiedTime }) {
      return {
        ...state,
        lockStaffName,
        lastModifiedTime
      };
    },
    parseWorkFlowData(state, { payload }) {
      const { formData } = state;
      let newData = null;
      if (payload) {
        newData = triggerEvent(Object.assign({}, { formData, layoutsAllConfig: payload }, { action: 'onGetWorkFlowData' }));
      }
      return {
        ...state,
        formData: Object.assign({}, newData || formData)
      };
    },
    initDva(state) {
      return {
        ...state,
        layoutNodes: [],
        mobileLayout: [],
        layoutsAllConfig: {},
        runtimeAllConfig: {},
        pageConfig: _.cloneDeep(initPageConfig),
        pageInfo: {},
        supLinkInfo: {},
        linkPage: {},
        innerPage: {},
        pageType: '',
        widgetCount: 0
      };
    },
    saveLayoutsInfo(state, { payload }) {
      const {
        pageConfig,
        layoutNodes,
        type,
        layouts,
        isRuntime,
        formatRuntimeConfig,
        pageInfo,
        supLinkInfo,
        mobileLayout,
        appId,
        kind
      } = payload;

      // 区块配置信息
      const layoutsAllConfig = {};
      const runtimeAllConfig = {};
      let widgetCount = 0;
      if (layouts.length) {
        _.forEach(layouts, (nodeItem) => {
          const itemConfig = nodeItem.context ?
            JSON.parse(nodeItem.context)
            : {};
          layoutsAllConfig[nodeItem.name] = itemConfig;
          const configArr = _.get(itemConfig, 'context.jsonData.d', []);

          // 计算layout 有多少控件
          const configObj = {};
          // 将数组转为对象形式便于后面递归判断
          _.forEach(configArr, (item) => { configObj[item.i] = item; });
          _.forEach(configObj, (item = {}) => {
            const image = _.get(item, 'p.image', '');
            if (image === 'htDiv') {
              if (recursiveIsVisable(item, configObj)) {
                widgetCount += 1;
              }
            }
          });

          if (isRuntime && formatRuntimeConfig[`runtime_${nodeItem.id}`]) {
            try {
              runtimeAllConfig[nodeItem.name] = JSON.parse(formatRuntimeConfig[`runtime_${nodeItem.id}`]);
            } catch (error) {
              console.error(error);
            }
          }
        });
      }

      if (mobileLayout.length) {
        _.forEach(mobileLayout, (mobileLayoutItem, mobileLayoutIndex) => {
          let mobileWidgetCount = 0;
          _.forEach(mobileLayoutItem.mobileLayoutNodes, (nodeItem) => {
            const nodeItemConfig = layoutsAllConfig[nodeItem.i];
            const configArr = _.get(nodeItemConfig, 'context.jsonData.d', []);
            // 计算layout 有多少控件
            mobileWidgetCount += configArr && configArr.filter((config) => {
              return _.get(config, 'p.image', '') === 'htDiv';
            }).length;
          });
          mobileLayout[mobileLayoutIndex].widgetCount = mobileWidgetCount;
        });
      }
      if (layoutNodes && layoutNodes[0]) {
        layoutNodes[0].kind = kind;
      }
      return {
        ...state,
        appId,
        layoutNodes,
        mobileLayout,
        layoutsAllConfig,
        runtimeAllConfig,
        pageConfig,
        pageType: type,
        pageInfo,
        supLinkInfo,
        widgetCount
      };
    },
    saveLinkInnerPageInfo(state, { payload }) {
      const { type, url, pageInfo = {}, supLinkInfo } = payload;
      const innerPage = {};
      const { resourceType, resourceCode } = JSON.parse(url);
      if (resourceType === 'app' || resourceType === 'business') { // 链接app页面
        innerPage.type = '0';
        innerPage.url = `/#/runtime-fullscreen/runtime-fullscreen/${resourceCode}`;
      } else if (resourceType === 'system') { // 链接内部页面
        innerPage.type = '1';
        innerPage.linkId = resourceCode;
      }
      return {
        ...state,
        innerPage,
        pageType: type,
        pageInfo,
        supLinkInfo
      };
    },
    saveLinkPageInfo(state, { payload }) {
      const { type, pageInfo = {}, supLinkInfo } = payload;
      return {
        ...state,
        linkPage: payload,
        pageType: type,
        pageInfo,
        supLinkInfo
      };
    },
    increaseLayout(state, { gridInfo, insertIndex }) {
      const { layoutsAllConfig, layoutNodes } = state;
      if (typeof insertIndex === 'number') {
        layoutNodes.splice(insertIndex, 0, gridInfo);
      } else {
        layoutNodes.push(gridInfo);
      }
      layoutsAllConfig[gridInfo.i] = {};
      return {
        ...state,
        layoutNodes,
        layoutsAllConfig
      };
    },
    updateLayoutNodes(state, { layoutNodes }) {
      return {
        ...state,
        layoutNodes
      };
    },
    updateLayoutAllConfig(state, { layoutsAllConfig }) {
      return {
        ...state,
        layoutsAllConfig
      };
    },
    deleteLayout(state, { i }) {
      const { layoutsAllConfig } = state;
      delete layoutsAllConfig[i];
      return {
        ...state,
        layoutNodes: _.reject(state.layoutNodes, { i }),
        layoutsAllConfig
      };
    },
    updatePageInfo(state, { payload }) {
      return {
        ...state,
        pageInfo: Object.assign(state.pageInfo, payload)
      };
    },
    updatePageConfig(state, { pageConfig }) {
      return {
        ...state,
        pageConfig
      };
    },
    updateMobileLayout(state, { mobileLayout }) {
      return {
        ...state,
        mobileLayout
      };
    },
    initFormData(state) {
      return {
        ...state,
        formData: {}
      };
    },
    updateFormData(state, { payload }) {
      const { formData } = payload;
      if (formData && formData['']) delete formData[''];
      return {
        ...state,
        ...payload,
        formData: Object.assign({}, state.formData, formData),
        readOnly: payload.readOnly !== undefined ? payload.readOnly : state.readOnly
      };
    },
    getPage(state, { payload }) {
      const { business, app } = payload;
      const businessResources = business.resource && business.resource.childResources && business.resource.childResources[0].childResources ? business.resource.childResources[0].childResources : [];
      const appResources = app.resource && app.resource.childResources ? app.resource.childResources : [];
      const list = [];

      businessResources.forEach((item) => {
        list.push(item);
      });

      appResources.forEach((item) => {
        if (item.childResources && item.childResources.length !== 0) {
          list.push(item);
        }
      });

      return {
        ...state,
        pageLayout: list
      };
    }
  }
};
